module.exports = {
  api: {
    API_URL: "https://app.petroatl.com/api",
    MEDIABASE_URL: "https://petrosolution.s3.us-east-2.amazonaws.com/",
    // API_URL: "http://localhost:5000/api",
  }
};